import { field, date, children, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { RECHARGE_SCHEMA } from '../schema';

export default class Recharge extends Model {
    static table = RECHARGE_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        payment: { type: 'has_many', foreignKey: 'wallet_txns_id' },
    }

    @text('transaction_status') transaction_status;
    @text('dispute_status') dispute_status;
    @text('transferred_to') transferred_to;
    @text('transaction_id') transaction_id;
    @text('customer_name') customer_name;
    @text('deposited_by') deposited_by;
    @text('reference_id') reference_id;
    @text('payment_mode') payment_mode;
    @text('to_account') to_account;
    @text('offer_name') offer_name;
    @field('commission') commission;
    @text('offer_key') offer_key;
    @field('cash_back') cash_back;
    @text('customer') customer;
    @field('balance') balance;
    @text('service') service;
    @field('amount') amount;
    @text('type') type;
    @text('mode') mode;

    @date('created_at') created_at;

    @relation('business', 'business_id') business;

    @children('payment') payment;
}